@if (title){
  <div class="bg-light text-primary text-center py-6">
    <h4 class="m-0 text-bold">{{ title }}</h4>
  </div>
}

